var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-button',{attrs:{"icon":"el-icon-refresh","loading":_vm.loading},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("\n  "+_vm._s(_vm.label || _vm.$t('settings.refresh'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }